export default "__VITE_ASSET__D3lZ7vtU__"